import * as React from 'react';
import { FavoritesAssignWidgetContainer } from '@cian/favorites-assign-widget';
import { useSelector } from 'react-redux';
import { getOffers } from '../../selectors/offers';
import { getPosition } from '../../utils/offer/getPosition';
import { trackCreateFolder, trackSaveToFolder } from '../../serp/components/offers/tracking';
import { getIsFavoritesFoldersEnabled } from '../../selectors';
import { getUser } from '../../selectors/user';
import { FavoritesFolders } from '../../components/FavoritesFolders';

export function FavoritesFoldersContainer() {
  const offers = useSelector(getOffers);
  const isFeatureEnabled = useSelector(getIsFavoritesFoldersEnabled);
  const { isAuthenticated } = useSelector(getUser);

  if (!isFeatureEnabled) {
    return null;
  }

  const handleCreate = (name: string, offerId: number) => {
    const position = getPosition(offerId, offers);
    trackCreateFolder({ offerId, position });
  };

  const handleSave = (offerId: number) => {
    const position = getPosition(offerId, offers);
    trackSaveToFolder({ offerId, position });
  };

  const handleLogin = () => {
    if (window.waitForLoginPopup) {
      window.waitForLoginPopup('favorites');
    }
  };

  return (
    <FavoritesFolders>
      <FavoritesAssignWidgetContainer
        isAuthenticated={isAuthenticated}
        onCreateFolder={handleCreate}
        onSaveOffer={handleSave}
        onWaitForLogin={handleLogin}
      />
    </FavoritesFolders>
  );
}
